import { useState, useCallback, useEffect } from 'react';
import { Page, Layout, Tabs, Popover, ActionList, Button, Modal } from '@shopify/polaris';
import PageMarkup from '../../common/PageMarkup';
import CustomTemplates from '../Templates/CustomTemplates/CustomTemplates';
import {
  CAMPAIGNSPAGE, CAMPAIGNS_TEMPLATES_GUIDE, TUTORIAL_VIDEOS
} from '../../constants/constants';
import MyCampaigns from './MyCampaigns';
import CampaignsTemplates from './CampaignsTemplates';
import "./index.scss";
import { PlusMinor, PlayCircleMajor } from '@shopify/polaris-icons';
import { clevertapEventPush, CT_EVENT_IDS } from '../../utils/clevertapUtils';
import MarketingGuideModal from './MarketingGuideModal';

const CommonTemplates = (props: any) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [currentSelectedTemplateId, setCurrentSelectedTemplateId] = useState(props?.location?.state || '');
  const [popoverActive, setPopoverActive] = useState(false);
  const [tutorialVideos, setTutorialVideos] = useState([]);
  const [videoTutorial, setVideoTutorial] = useState({
    open: false,
    videoSrc: ''
  });
  const [open_marketing_campaign_modal, setopen_marketing_campaign_modal] = useState(false);
  const [marketing_campaign_modal_steps_completed] = useState(false);
  const [guideStep, setGuideStep] = useState(0);
  const [openGuide, setOpenGuide] = useState(false);

  const marketingCampaignModalStepsCompleted = () => {
    setopen_marketing_campaign_modal(false);
  };

  const closeMarketingCampaignGuideModal = () => {
    setopen_marketing_campaign_modal(false);
    if(guideStep<4){
      clevertapEventPush({
        eventId: CT_EVENT_IDS.GUIDE_CLOSED,
        eventData: {},
      });
    }
    else if(guideStep==4){
      clevertapEventPush({
        eventId: CT_EVENT_IDS.GUIDE_COMPLETED,
        eventData: {},
      });
    }
  };

  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    [],
  );
  const activator = (
    <div className="videoTutsButton">
      <Button icon={PlayCircleMajor} onClick={togglePopoverActive} disclosure>
        {TUTORIAL_VIDEOS.TITLE}
      </Button>
    </div>
  );

  useEffect(() => {
    let tmpData: any = [];
    if(selectedTab == 0){
      TUTORIAL_VIDEOS.MY_CAMPAIGNSPAGE.forEach((video: any) => {
        let tmpStep = {
          content: video.content,
          onAction: () => showVideoModal(video.videoSrc),
        }
        tmpData.push(tmpStep);
      });
      setTutorialVideos(tmpData);
    }
    else{
      TUTORIAL_VIDEOS.CAMPAIGNS_TEMPLATES.forEach((video: any) => {
        let tmpStep = {
          content: video.content,
          onAction: () => showVideoModal(video.videoSrc),
        }
        tmpData.push(tmpStep);
      });
      setTutorialVideos(tmpData);
    }
  }, [selectedTab]);

  const showVideoModal = (videoLinks: string) => {
    setVideoTutorial({ open: true, videoSrc: videoLinks });
  };

  const tabContent = [
    <MyCampaigns currentSelectedTemplateId={currentSelectedTemplateId} setCurrentSelectedTemplateId={setCurrentSelectedTemplateId} />,
    <CampaignsTemplates privateWabaDetails={props.privateWabaDetails} setSelectedTab={setSelectedTab}></CampaignsTemplates>
  ]

  const handleTabChange = useCallback((selectedTabIndex) => {
    setSelectedTab(selectedTabIndex);
  }, []);

  useEffect(() => {
    setCurrentSelectedTemplateId(props.location.state);
  }, [props.location.state])

  const renderContent = () => {
    let totalTabs = CAMPAIGNSPAGE.TABS.length;
    let template = tabContent[0];
    for (let i = 0; i <= totalTabs; i++) {
      if (selectedTab === i) {
        template = tabContent[selectedTab];
      }
    }
    return template;
  };

  return (
    <>
      <div className='flexrightAlign gap1'>
        <Popover
          active={popoverActive}
          activator={activator}
          onClose={togglePopoverActive}
        >
          <ActionList
            actionRole="tutorialVideo"
            items={tutorialVideos}
          />
        </Popover>
        <div
          className='tooltip-outer-container '
          onClick={() => {
            if(selectedTab == 0){
              setopen_marketing_campaign_modal(true);
              clevertapEventPush({
                eventId: CT_EVENT_IDS.GUIDE_STARTED,
                eventData: {},
              });
            }
            else{
              setOpenGuide(true);
              clevertapEventPush({
                eventId: CT_EVENT_IDS.GUIDE_STARTED,
                eventData: {},
              });
            }

          }}>
          <div className='icon'>
            <img
              alt='Success Icon'
              src='/static/media/tooltip.5d6067ae.svg'
              title='Guide'
              className='tooltip-svg-icon'
            />
          </div>
        </div>
      </div>
      <Page title={CAMPAIGNSPAGE.TITLE} >
        <Layout>
          <div className='w-100'>
            <Tabs tabs={CAMPAIGNSPAGE.TABS} selected={selectedTab} onSelect={handleTabChange}>
              {renderContent()}
            </Tabs>
          </div>
        </Layout>
        <Modal
            open={videoTutorial.open}
            sectioned={true}
            title={TUTORIAL_VIDEOS.TITLE}
            onClose={() => {
              setVideoTutorial({ open: false, videoSrc: '' });
            }}
          >
            <iframe
              id='ytplayer'
              width='100%'
              height='360'
              allow='fullscreen'
              src={videoTutorial.videoSrc}
              frameBorder='0'
              title={TUTORIAL_VIDEOS.TITLE}
            ></iframe>
          </Modal>
          {open_marketing_campaign_modal ? (
            <MarketingGuideModal
              open={true}
              completed={marketing_campaign_modal_steps_completed}
              closeModal={closeMarketingCampaignGuideModal}
              stepsCompleted={marketingCampaignModalStepsCompleted}
              shopName={localStorage.getItem('shop')}
              setGuideStep={setGuideStep}
            />
          ) : null}
          <Modal
            open={openGuide}
            sectioned={true}
            title={CAMPAIGNS_TEMPLATES_GUIDE.TITLE}
            onClose={() => {
              setOpenGuide(false);
            }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: `${CAMPAIGNS_TEMPLATES_GUIDE.CONTENT}`,
            }}
          ></div>
        </Modal>
      </Page>
    </>
  );
};
export default CommonTemplates;